const navlinks = [
  { name: "Home", path: "/" },
  { name: "Products", path: "/products" },
  { name: "About Us", path: "/#about-us" },
  { name: "Our Story", path: "/#our-story" },
  { name: "Contact us", path: "/#contact-us" },
];

export default navlinks;
